/**
 * SENSHI CART OVERRIDE
 * Handles custom add-to-cart for Senshi bag products:
 *   - Inner Print selection (updates variant ID)
 *   - Strap Colour as line item property
 *   - Optionally adds Embroidery product with text
 *   - Redirects to /cart after add
 */
(function () {
  'use strict';

  var configEl = document.getElementById('senshi-config');
  if (!configEl) return;

  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { console.error('[Senshi] Config parse error:', e); return; }
  if (!config || !config.isSenshiBag) return;

  // DOM refs
  var printSwatches = document.querySelectorAll('#senshi-print-swatches .senshi-swatch');
  var printSelectedDisplay = document.getElementById('senshi-print-selected');
  var strapSwatches = document.querySelectorAll('#senshi-strap-swatches .senshi-swatch');
  var strapSelectedDisplay = document.getElementById('senshi-strap-selected');
  var embToggle = document.getElementById('senshi-embroidery-toggle');
  var embFields = document.getElementById('senshi-embroidery-fields');
  var embTextInput = document.getElementById('senshi-embroidery-text');
  var charCurrent = document.getElementById('senshi-char-current');

  var form = document.querySelector('.js-product-form');
  if (!form) { console.warn('[Senshi] Product form not found'); return; }

  // ── English-only regex: A-Z, a-z, 0-9, space, hyphen, apostrophe, period ──
  var ENGLISH_ONLY = /^[A-Za-z0-9 \-'.]*$/;

  function stripNonEnglish(str) {
    return str.replace(/[^A-Za-z0-9 \-'.]/g, '');
  }

  // --- Inner Print swatch interaction ---
  printSwatches.forEach(function (swatch) {
    swatch.addEventListener('click', function (e) {
      if (swatch.dataset.available === 'false') { e.preventDefault(); return; }
      printSwatches.forEach(function (s) { s.classList.remove('senshi-swatch--active'); });
      swatch.classList.add('senshi-swatch--active');
      swatch.querySelector('input[type="radio"]').checked = true;

      var variantId = swatch.dataset.variantId;
      var variantInput = form.querySelector('input[name="id"]');
      if (variantInput && variantId) {
        variantInput.value = variantId;
      }

      if (printSelectedDisplay) {
        printSelectedDisplay.textContent = swatch.dataset.value;
      }
    });
  });

  // --- Strap swatch interaction ---
  strapSwatches.forEach(function (swatch) {
    swatch.addEventListener('click', function (e) {
      if (swatch.dataset.available === 'false') { e.preventDefault(); return; }
      strapSwatches.forEach(function (s) { s.classList.remove('senshi-swatch--active'); });
      swatch.classList.add('senshi-swatch--active');
      swatch.querySelector('input[type="radio"]').checked = true;
      if (strapSelectedDisplay) {
        strapSelectedDisplay.textContent = swatch.dataset.colour;
      }
    });
  });

  // --- Embroidery toggle + live PDP price update ---
  var priceEl = document.querySelector('.product-single__box__block--price .price__number--sale .money');
  var basePriceCents = null;
  var basePriceCurrencySuffix = '';
  if (priceEl) {
    var match = priceEl.textContent.match(/([\d,]+(?:\.\d+)?)/);
    if (match) {
      basePriceCents = Math.round(parseFloat(match[1].replace(/,/g, '')) * 100);
      basePriceCurrencySuffix = priceEl.textContent.replace(match[1], '').replace(/^\$/, '').trim();
    }
  }
  function formatBagMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars + (basePriceCurrencySuffix ? ' ' + basePriceCurrencySuffix : '');
  }
  function updateBagPrice() {
    if (basePriceCents === null || !priceEl) return;
    var addOn = (embToggle && embToggle.checked) ? (config.embroideryPrice || 0) : 0;
    priceEl.textContent = formatBagMoney(basePriceCents + addOn);
  }

  if (embToggle && embFields) {
    embToggle.addEventListener('change', function () {
      embFields.style.display = embToggle.checked ? 'block' : 'none';
      if (!embToggle.checked && embTextInput) {
        embTextInput.value = '';
        if (charCurrent) charCurrent.textContent = '0';
        clearEmbroideryError();
      }
      if (embToggle.checked && embTextInput) embTextInput.focus();
      updateBagPrice();
    });
  }

  // --- Real-time: strip non-English characters as customer types ---
  if (embTextInput) {
    embTextInput.addEventListener('input', function () {
      var cursor = embTextInput.selectionStart;
      var original = embTextInput.value;
      var cleaned = stripNonEnglish(original);

      if (cleaned !== original) {
        embTextInput.value = cleaned;
        // Restore cursor position, accounting for removed characters
        var removed = original.length - cleaned.length;
        embTextInput.setSelectionRange(cursor - removed, cursor - removed);
        showEmbroideryError('English characters only (A-Z, 0-9, spaces and basic punctuation).');
      } else {
        clearEmbroideryError();
      }

      if (charCurrent) charCurrent.textContent = embTextInput.value.length;
    });

    // Also catch paste events
    embTextInput.addEventListener('paste', function (e) {
      e.preventDefault();
      var pasted = (e.clipboardData || window.clipboardData).getData('text');
      var cleaned = stripNonEnglish(pasted).substring(0, 10);
      var start = embTextInput.selectionStart;
      var end = embTextInput.selectionEnd;
      var current = embTextInput.value;
      var newVal = (current.substring(0, start) + cleaned + current.substring(end)).substring(0, 10);
      embTextInput.value = newVal;
      if (charCurrent) charCurrent.textContent = newVal.length;
      if (pasted !== cleaned) {
        showEmbroideryError('Non-English characters were removed from your paste.');
      } else {
        clearEmbroideryError();
      }
    });
  }

  function showEmbroideryError(msg) {
    var el = document.getElementById('senshi-embroidery-error');
    if (el) { el.textContent = msg; el.style.display = 'block'; }
  }

  function clearEmbroideryError() {
    var el = document.getElementById('senshi-embroidery-error');
    if (el) { el.style.display = 'none'; }
  }

  // --- Intercept form ---
  form.addEventListener('submit', function (e) {
    if (!document.getElementById('senshi-bag-fields')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    handleSenshiAddToCart();
  }, true);

  var submitBtn = form.querySelector('[type="submit"], button[name="add"]');
  if (submitBtn) {
    submitBtn.addEventListener('click', function (e) {
      if (!document.getElementById('senshi-bag-fields')) return;
      e.preventDefault(); e.stopImmediatePropagation();
      handleSenshiAddToCart();
    }, true);
  }

  // --- Main add-to-cart ---
  async function handleSenshiAddToCart() {
    var printRadio = document.querySelector('input[name="senshi-print"]:checked');
    var bagVariantId = printRadio ? parseInt(printRadio.dataset.variantId, 10) : null;

    if (!bagVariantId) {
      var variantInput = form.querySelector('input[name="id"]');
      if (variantInput) bagVariantId = parseInt(variantInput.value || variantInput.getAttribute('value'), 10);
    }

    if (!bagVariantId) {
      showError('Please select an Inner Print.');
      return;
    }

    var strapRadio = document.querySelector('input[name="senshi-strap-colour"]:checked');
    var strapColour = strapRadio ? strapRadio.value : 'White';
    var strapVariantId = strapRadio ? strapRadio.dataset.variantId : null;

    var embroideryEnabled = embToggle ? embToggle.checked : false;
    var embroideryText = embTextInput ? embTextInput.value.trim() : '';

    if (embroideryEnabled && embroideryText.length === 0) {
      showError('Please enter your embroidery text.');
      embTextInput.focus();
      return;
    }
    if (embroideryEnabled && embroideryText.length > 10) {
      showError('Embroidery text must be 10 characters or less.');
      embTextInput.focus();
      return;
    }
    if (embroideryEnabled && !ENGLISH_ONLY.test(embroideryText)) {
      showError('Embroidery text must use English characters only.');
      embTextInput.focus();
      return;
    }

    var items = [];

    var bagItem = {
      id: bagVariantId,
      quantity: 1,
      properties: {
        'Strap Colour': strapColour
      }
    };
    if (strapVariantId) {
      bagItem.properties['_strap_variant_id'] = strapVariantId;
    }
    if (embroideryEnabled && embroideryText) {
      bagItem.properties['Strap Embroidery'] = embroideryText;
    }
    items.push(bagItem);

    if (embroideryEnabled && embroideryText) {
      items.push({
        id: config.embroideryVariantId,
        quantity: 1,
        properties: {
          'Embroidery Text': embroideryText
        }
      });
    }

    setButtonLoading(true);
    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!response.ok) {
        var errorData = await response.json();
        throw new Error(errorData.description || errorData.message || 'Could not add to cart');
      }
      window.location.href = '/cart';
    } catch (err) {
      console.error('[Senshi] Add to cart error:', err);
      showError(err.message || 'Error adding to cart. Please try again.');
      setButtonLoading(false);
    }
  }

  function setButtonLoading(loading) {
    var btn = form.querySelector('[type="submit"], button[name="add"], .js-add-to-cart');
    if (!btn) return;
    if (loading) { btn.setAttribute('disabled', 'disabled'); btn.classList.add('btn--loading', 'is-loading'); }
    else { btn.removeAttribute('disabled'); btn.classList.remove('btn--loading', 'is-loading'); }
  }

  function showError(msg) {
    var errorContainer = form.querySelector('.product-form__error, .js-form-error');
    if (errorContainer) {
      errorContainer.textContent = msg; errorContainer.style.display = 'block';
      setTimeout(function () { errorContainer.style.display = 'none'; }, 5000);
      return;
    }
    alert(msg);
  }
})();
